import React, { useEffect, useMemo, useRef, useState } from "react";
import "./FabricInquiryNewDetails.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons";
import { createB2BAPI } from "../../../api/Interceptor";
import { useNavigate } from "react-router-dom";
import B2BInput from "../../common/B2BInput";
import B2BSelect from "../../common/B2BSelect";
import { Button, FileButton, Group, NumberInput } from "@mantine/core";
import { IconArrowLeft, IconPercentage, IconUpload } from "@tabler/icons-react";
import { FaPlus, FaTrash } from "react-icons/fa";
import notify from "../../../utils/Notification";
import _ from "lodash";
import { Carousel } from "@mantine/carousel";
import { useLoader } from "../../../Context/LoaderContext";

const initialState = {
  productId: "",
  articleName: null,
  articleCode: null,
  description: "",
  supplier: "",
  isCreateBarcode: true,
  createBatch: false,
  hsnCode: "",
  fiber: "",
  mappedFabric: [],
  tags: [],
  metrics: {
    weight: 0,
    thickness: 0,
    length: 0,
    width: 0,
    inches: 0,
    centimeter: 0,
    meter: 0,
    meterSqKg: 0,
  },
  chargeRoll: false,
  vendorProductInfo: {
    sampleAvailable: false,
    swatchAvailable: false,
    swatchSent: "",
    swatchReceived: "",
    standardRollWt: "",
    costPrice: 0,
    commission: "",
    ussId: "",
    commissionPercentage: "",
    vendorProductId: "",
    coneWeight: "",
    vendorProductName: "",
    priceInclConeWeight: "",
  },
  otherInformation: {
    skuPrefix: "",
    coneWeight: "",
    unitOfMeasures: {
      type: "UOM",
      isKg: true,
      isMeter: false,
      isYard: false,
    },
  },
  productType: "",
  prodVariants: {},
  vendorProductCode: "",
  vendorProductName: "",
  productVariants: [],
  productCategories: {},
  newProductVariants: [],
  fabricContent: {
    value: "",
    composition: {},
  },
  totalProductPercent: "",
  vendorImage: "",
  vendorImages: [],
  priceSetting: {
    isMarkUp: false,
    isMarkDown: false,
    costPrice: 0,
    markUpPercent: 0,
    markDownPercent: 0,
    sellingPrice: 0,
    mrp: 0,
    margin: 0,
  },
  categoryId: "",
  brandId: "",
  status: "ACTIVE",
};

const VendorFabricInquiryNewDetails = () => {
  const navigate = useNavigate();
  const { showLoader, hideLoader } = useLoader();
  const [fCCValue, setFCCValue] = useState("");
  const [fabricValue, setFabricValue] = useState([]);
  const B2B_API = useMemo(() => createB2BAPI(navigate), [navigate]);
  const [chargeCondition, setChargeCondition] = useState("no");
  const [formData, setFormData] = useState(initialState);
  const [isNameEdited, setIsNameEdited] = useState(false);
  console.log(formData, "for")
  const [imageFile, setImageFile] = useState(null);
  const [imageStdFile, setStdImageFile] = useState(null);
  const [imagePreview, setImagePreview] = useState("");
  const [text, setText] = useState("");
  const [isChecked, setIsChecked] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const resetRef = useRef(null);
  const [lastChild, setLastChild] = useState([]);
  const [fabricContent, setFabricContent] = useState({});
  const [totalPercent, setTotalpercent] = useState(formData?.totalProductPercent || 0,);
  const [selectedPairsFabric, setSelectedPairsFabric] = useState([{ key: "", values: [], value: null },]);
  const hasValidFabricContent = selectedPairsFabric.some((pair) => pair.key && pair.value !== null);
  const [errors, setErrors] = useState({});
  console.log(errors, "eeoeok")
  const getAvailableKeysFabric = (currentIndex) => {
    const selectedKeys = selectedPairsFabric.map((pair) => pair.key);
    return Object.keys(keyToNameMap).filter(
      (key) =>
        !selectedKeys.includes(key) ||
        selectedPairsFabric[currentIndex].key === key,
    );
  };
  const validateForm = () => {
    let newErrors = {};

    if (!formData.articleCode || formData.articleCode.trim() === "") {
      newErrors.productId = "Vendor Product Id is required";
    }

    if (!formData.articleName || formData.articleName.trim() === "") {
      newErrors.productName = "Vendor Product Name is required";
    }
    if (!formData.metrics.weight || Number(formData.metrics.weight) <= 0) {
      newErrors.weight = "Weight is required";
    }

    if (!formData.metrics.width || Number(formData.metrics.width) <= 0) {
      newErrors.width = "Width is required";
    }

    if (
      !formData.priceSetting.costPrice ||
      Number(formData.priceSetting.costPrice) <= 0 || !formData.vendorProductInfo.costPrice || Number(formData.priceSetting.costPrice) <= 0) {
      newErrors.costPrice = "Price is required";
    }

    if (
      !formData.vendorProductInfo.commissionPercentage ||
      Number(formData.vendorProductInfo.commissionPercentage) <= 0
    ) {
      newErrors.commissionPercentage = "Commission % is required";
    }

    if (Number(formData.vendorProductInfo.commissionPercentage) > 100) {
      newErrors.commissionPercentage = "Commission cannot exceed 100%";
    }

    if (formData.chargeRoll === "true") {
      if (
        !formData.otherInformation.coneWeight ||
        Number(formData.otherInformation.coneWeight) <= 0
      ) {
        newErrors.coneWeight = "Cone Weight is required";
      }

      if (
        !formData.vendorProductInfo.standardRollWt ||
        Number(formData.vendorProductInfo.standardRollWt) <= 0
      ) {
        newErrors.standardRollWt = "Standard Weight is required";
      }
    }
    if (
      !formData.vendorProductInfo.commissionPercentage ||
      Number(formData.vendorProductInfo.commissionPercentage) <= 0
    ) {
      newErrors.commissionPercentage = "commission Percentage is required";
    }


    if (
      !formData.fabricContent ||
      Object.keys(formData.fabricContent.composition || {}).length === 0
    ) {
      newErrors.fabricContent = "Fabric composition is required";
    }

    if (Number(totalPercent) !== 100) {
      newErrors.fabricPercent = "Fabric composition must equal 100%";
    }
    if (!formData.fiber || formData.fiber.trim() === "") {
      newErrors.fiber = "Fiber is required";
    }
    const allImages =
      imageFile?.length > 0 ? imageFile : formData?.vendorImages || [];

    if (!allImages || allImages.length === 0) {
      newErrors.images = "Please upload at least one image";
    }

    if (!isChecked) {
      newErrors.checkbox =
        "Please confirm that this development is related to a single fabric";
    }

    setErrors(newErrors);

    console.log("Validation Errors:", newErrors);

    return Object.keys(newErrors).length === 0;
  };
  const fabricContentCode = async (newPairs) => {
    try {
      const results = await Promise.all(
        Object.entries(newPairs).map(async ([key, value]) => {
          const res = await B2B_API.get(
            `product-category/category/${key}`,
          ).json();
          const name = res.response.name;
          const fcc = name.substring(0, 3).toUpperCase();
          console.log(res, "res");
          return `${fcc}-${value}%`;
        }),
      );
      const formattedFCC = results.join(" ");
      setFormData((prevState) => ({
        ...prevState,
        fabricContent: {
          ...prevState.fabricContent,
          value: formattedFCC,
        },
      }));
      setFCCValue(formattedFCC);
    } catch (error) {
      console.error("Error fetching category data: ", error);
    }
  };
  const allImages = imageFile?.length > 0 ? imageFile : formData?.vendorImages || [];
  const allstandardColorOptionsImages = imageStdFile?.length > 0 ? imageStdFile : formData?.standardColorOptions || [];

  const fileChangee = (files) => {
    if (!files || files.length === 0) return;
    const validFiles = Array.from(files).filter((file) =>
      ["image/jpeg", "image/png"].includes(file.type)
    );
    if (validFiles.length === 0) {
      setImageError("Only PNG or JPEG files are allowed.");
      return;
    }
    setImageFile((prev) => [...(prev || []), ...validFiles]);
    setImageError(null);
  };
  const removeSingleFile = (index) => {
    setImageFile((prev) => prev.filter((_, i) => i !== index));
  };
  const removeSingleStdFile = (index) => {
    setStdImageFile((prev) => prev.filter((_, i) => i !== index));
  };
  const fileStdChangee = (files) => {
    if (!files || files.length === 0) return;
    const validFiles = Array.from(files).filter((file) =>
      ["image/jpeg", "image/png"].includes(file.type)
    );
    if (validFiles.length === 0) {
      setStdImageError("Only PNG or JPEG files are allowed.");
      return;
    }
    setStdImageFile((prev) => [...(prev || []), ...validFiles]);
    setStdImageError(null);
  };
  const clearFilee = () => {
    setImageFile([]);
    resetRef.current?.();
  };
  const clearStdFilee = () => {
    setStdImageFile([]);
    resetRef.current?.();
  };
  const handleSelectChangeFabric = (index, selectedValue) => {
    const newPairs = [...selectedPairsFabric];
    const oldKey = newPairs[index].key;
    const oldValue = parseInt(newPairs[index].value, 10) || 0;
    newPairs[index].key = selectedValue || "";
    newPairs[index].value = selectedValue ? newPairs[index].value : "";
    const newValue = parseInt(newPairs[index].value, 10) || 0;
    const updatedTotal = totalPercent - oldValue + newValue;
    setTotalpercent(updatedTotal);
    setSelectedPairsFabric(newPairs);
    setFormData((prevState) => {
      const updatedComposition = { ...prevState.fabricContent.composition };
      if (oldKey && oldKey !== selectedValue) {
        delete updatedComposition[oldKey];
      }
      if (selectedValue) {
        updatedComposition[selectedValue] = newPairs[index].value || 0;
      }
      return {
        ...prevState,
        totalProductPercent: updatedTotal,
        fabricContent: {
          ...prevState.fabricContent,
          composition: updatedComposition,
        },
      };
    });
    const pairsObject = newPairs.reduce((acc, pair) => {
      if (pair.key && pair.value) {
        acc[pair.key] = pair.value;
      }
      return acc;
    }, {});
    if (Object.keys(pairsObject).length > 0) {
      fabricContentCode(pairsObject);
      setFCCValue((prev) => {
        const existingValues = prev ? prev.split(" ") : [];
        const newValues = Object.entries(pairsObject).map(([key, value]) => {
          const fcc = keyToNameMap[key]?.substring(0, 3).toUpperCase() || "";
          return `${fcc}-${value}%`;
        });
        const updatedValues = [
          ...new Set([...existingValues, ...newValues]),
        ].join(" ");
        return updatedValues;
      });
    } else {
      setFCCValue("");
      setFormData((prevState) => ({
        ...prevState,
        fabricContent: {
          ...prevState.fabricContent,
          value: "",
        },
      }));
    }
  };
  useEffect(() => {
    fetchFabricContent();
    setFCCValue(formData?.fabricContent?.value);
    getFabricValues();
  }, []);

  const fetchFabricContent = async () => {
    try {
      const res = await B2B_API.get("product-category?status=ACTIVE").json();
      console.log(res, "rex ss");
      const categories = res.response;
      const category = categories.find((cat) => cat.name === "Fabric Content");
      setFabricContent(category);
      setSelectedPairsFromProductFabric();
    } catch (error) {
      console.error("Error fetching fabric content:", error);
    }
  };

  const setSelectedPairsFromProductFabric = () => {
    const { fabricContent } = formData;
    const keys = Object.keys(fabricContent?.composition);
    if (_.size(keys) > 0) {
      setSelectedPairsFabric(
        _.map(keys, (key) => ({
          key,
          value: fabricContent?.composition[key],
        })),
      );
    }
  };
  function findEmptyChildNodes(node) {
    const result = [];
    function traverse(node) {
      if (node && node.child && node.child.length === 0) {
        result.push(node);
      }
      if (node && node.child) {
        node.child.forEach(traverse);
      }
    }
    traverse(node);
    return result;
  }
  const keyToNameMap = lastChild.reduce((map, item) => {
    map[item.categoryId] = item.name;
    return map;
  }, {});
  useEffect(() => {
    if (fabricContent) {
      const emptyNodes = findEmptyChildNodes(fabricContent);
      setLastChild(emptyNodes);
    }
  }, [fabricContent]);
  const handleMultiSelectChangeFabric = (index, value) => {
    const newPairs = [...selectedPairsFabric];
    const key = newPairs[index].key;
    const previousValue = parseInt(newPairs[index].value, 10) || 0;
    const updatedTotal = totalPercent - previousValue + value;
    if (key) {
      newPairs[index].value = value;
      setSelectedPairsFabric(newPairs);
      setTotalpercent(updatedTotal);
      setFormData((prevState) => ({
        ...prevState,
        totalProductPercent: updatedTotal,
        fabricContent: {
          ...prevState.fabricContent,
          composition: {
            ...prevState.fabricContent.composition,
            [key]: value,
          },
        },
      }));
      const pairsObject = newPairs.reduce((acc, pair) => {
        if (pair.key && pair.value) {
          acc[pair.key] = pair.value;
        }
        return acc;
      }, {});
      fabricContentCode(pairsObject);
    }
  };

  const addNewPairFabric = () => {
    const totalSum = _.sumBy(selectedPairsFabric, (item) =>
      parseInt(item.value),
    );
    if (totalSum < 100) {
      setSelectedPairsFabric([...selectedPairsFabric, { key: "", value: "" }]);
    }
  };
  const removePairFabric = (index, value) => {
    const newPairs = [...selectedPairsFabric];
    const removedKey = newPairs[index].key;
    const updatedTotal = totalPercent - value;
    setTotalpercent(updatedTotal);
    newPairs.splice(index, 1);
    setSelectedPairsFabric(newPairs);
    const pairsObject = newPairs.reduce((acc, pair) => {
      if (pair.key && pair.value) {
        acc[pair.key] = pair.value;
      }
      return acc;
    }, {});
    fabricContentCode(pairsObject);
    setFormData((prevState) => {
      const { [removedKey]: _, ...newComposition } =
        prevState.fabricContent?.composition;
      return {
        ...prevState,
        totalProductPercent: updatedTotal,
        fabricContent: {
          ...prevState.fabricContent,
          composition: newComposition,
          value: fCCValue,
        },
      };
    });
  };

  const ChangeHandlerFabric = (selectedValue) => {
    if (!selectedValue) {
      setFCCValue("");
      setSelectedPairsFabric([{ key: "", values: [], value: null }]);
      setTotalpercent(0);
      setFormData((prevState) => ({
        ...prevState,
        totalProductPercent: 0,
        fabricContent: {
          ...prevState.fabricContent,
          composition: {},
          value: "",
        },
      }));
      return;
    }
    const selectedFabric = fabricValue.find(
      (fabric) => fabric.value === selectedValue,
    );
    const compositionArray = Object.entries(selectedFabric?.composition);

    const pair =
      selectedFabric && selectedFabric.value
        ? selectedFabric.value.split(" ").reduce((acc, item) => {
          const [key, value] = item.split("-");
          acc.push(parseInt(value));
          return acc;
        }, [])
        : [];

    const valueOrderMap = pair.reduce((acc, value, index) => {
      acc[value] = index;
      return acc;
    }, {});

    const selectedPairs = compositionArray.sort((a, b) => {
      return valueOrderMap[a[1]] - valueOrderMap[b[1]];
    });
    setSelectedPairsFabric(
      selectedPairs.map(([key, value]) => ({ key, value })),
    );
    const totalSum = selectedPairs.reduce(
      (sum, [_, value]) => sum + parseInt(value, 10) || 0,
      0,
    );
    setTotalpercent(totalSum);
    const pairsObject = selectedPairs.reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
    if (Object.keys(pairsObject).length > 0) {
      setFormData((prevState) => ({
        ...prevState,
        totalProductPercent: totalSum,
        fabricContent: {
          ...prevState.fabricContent,
          composition: pairsObject,
        },
      }));
      fabricContentCode(pairsObject);
    } else {
      setFCCValue("");
      setSelectedPairsFabric([{ key: "", values: [], value: null }]);
      setFormData((prevState) => ({
        ...prevState,
        totalProductPercent: 0,
        fabricContent: {
          ...prevState.fabricContent,
          composition: {},
          value: "",
        },
      }));
    }
  };
  const getFabricValues = async () => {
    try {
      const res = await B2B_API.get(`fabric?status=ACTIVE`).json();
      setFabricValue(res?.response);
    } catch (error) {
      console.error("Error fetching fabric values: ", error);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "weight") {
      setFormData((prev) => ({
        ...prev,
        metrics: {
          ...prev.metrics,
          weight: value,
        },
      }));
      return;
    }
    if (name === "width") {
      setFormData((prev) => ({
        ...prev,
        metrics: {
          ...prev.metrics,
          width: value,
        },
      }));
      return;
    }
    if (name === "coneWeight") {
      setFormData((prev) => ({
        ...prev,
        otherInformation: {
          ...prev.otherInformation,
          coneWeight: value,
        },
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          coneWeight: value,
        },
      }));
      return;
    }
    if (name === "standardRollWt") {
      setFormData((prev) => ({
        ...prev,
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          standardRollWt: value,
        },
      }));
      return;
    }
    if (name === "costPrice") {
      setFormData((prev) => ({
        ...prev,
        priceSetting: {
          ...prev.priceSetting,
          costPrice: value,
        },

        vendorProductInfo: {
          ...prev.vendorProductInfo,
          costPrice: value,
        },
      }));
      return;
    }
    if (name === "commissionPercentage") {
      if (value > 100) return;
      setFormData((prev) => ({
        ...prev,
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          commissionPercentage: value,
        },
      }));
      return;
    }
    if (name === "productId") {
      setFormData((prev) => ({
        ...prev,
        articleCode: value,
        vendorProductCode: value,
        ...(isNameEdited ? {} : {
          articleName: value,
          vendorProductName: value,
        }),
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          vendorProductId: value,
          ...(isNameEdited ? {} : {
            vendorProductName: value,
          }),
        },
      }));
      return;
    }
    if (name === "productName") {
      if (value && typeof value === "string" && value.trim() !== "") {
        setIsNameEdited(true);
      } else {
        setIsNameEdited(false);
      }
      setFormData((prev) => ({
        ...prev,
        articleName: value,
        vendorProductName: value,
        vendorProductInfo: {
          ...prev.vendorProductInfo,
          vendorProductName: value,
        },
      }));
      return;
    }

    if (name === "uom") {
      setFormData((prev) => ({
        ...prev,
        otherInformation: {
          ...prev.otherInformation,
          unitOfMeasures: {
            type: "UOM",
            isKg: value === "isKg",
            isMeter: value === "isMeter",
            isYard: value === "isYard",
          },
        },
      }));
      return;
    }

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleImageChange = (e) => {
    const file = e.target.files[0];
    setImageFile(file);
    if (file) {
      const previewUrl = URL.createObjectURL(file);
      setImagePreview(previewUrl);
    }
  };

  const handleCheckboxClick = () => {
    setIsChecked((prevChecked) => !prevChecked);
  };
  const handleFabricInquirySave = async (e) => {
    e.preventDefault();
    if (isSubmitting) return;
    if (!validateForm()) {
      return;
    }
    setIsSubmitting(true);
    const formDataa = new FormData();
    let updatedProduct = {
      ...formData,
    };
    updatedProduct.draftProductType = 'INQUIRY'
    updatedProduct.otherInformation?.unitOfMeasures?.isMeter && (updatedProduct.otherInformation.yard = convertMeterToYard());
    formDataa.append("product", JSON.stringify(updatedProduct))
    imageFile && imageFile.forEach(r => { formDataa.append("image", r) })
    imageStdFile && imageStdFile.forEach(r => { formDataa.append("standardColorOptions", r) })
    addFabricInquiry(formDataa);
  };
  const convertMeterToYard = () => {
    const res = formData.otherInformation.meter * 1.09632;
    return res.toFixed(2);
  };
  const addFabricInquiry = async (prod) => {
    showLoader();
    try {
      console.log(prod, "rpooddd")
      const res = await B2B_API.post(`inquiryProduct/add`, {
        body: prod,
      }).json();
      setFormData(initialState);
      setSelectedPairsFabric([{ key: "", value: "" }]);
      setTotalpercent(0);
      setFCCValue("");
      notify({
        title: "Success!!",
        message: res?.message || "Development Submitted Successfully",
        success: true,
      });
      navigate('/vendorFabricInquiries')
    } catch (err) {
      notify({
        title: "Error!!",
        message: err?.message || "Failed to Submit Development.",
        error: true,
        success: false,
      });
      setIsSubmitting(false);
    } finally {
      hideLoader();
    }
  };

  return (
    <div className="view-create-fabric-inquiry router-view-container">
      <div className="content">
        <div className="page-title" style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
          <span className="text">
            New Development <i className="icon far fa-search"></i>
          </span>
          <Button
            color='#8BC54F'
            onClick={() => navigate("/vendorFabricInquiries")}
            leftSection={<IconArrowLeft stroke={2} />}
          >
            Back
          </Button>
        </div>
        <div className="flex-layout">
          <div className="inquiry-text-container">
            <div className="inquiry-description">
              <div className="description-title">How does this work?</div>
              <div className="description-content">
                After you submit your new development, our merchandiser team will evaluate the product based on our target customer requirements. The more details you provide in this form, the better our merchandiser team will be able to evaluate the new development.
              </div>
            </div>
          </div>
          <div className="form-container">
            <form className="form" onSubmit={handleFabricInquirySave} style={{ pointerEvents: isSubmitting ? "none" : "auto", opacity: isSubmitting ? 0.7 : 1 }}>
              <div className="form-control">
                <label>Vendor Product Id<span style={{ color: "red" }}> *</span></label>
                <input
                  name="productId"
                  placeholder="Enter Id"
                  className="required-but-empty"
                  value={
                    formData?.articleCode ||
                    formData?.vendorProductInfo?.vendorProductId
                  }
                  onChange={handleChange}
                  type="texy"
                />
                {errors.productId && (
                  <span className="error-text" style={{ color: "red" }}>{errors.productId}</span>
                )}
              </div>
              <div className="form-control">
                <label>Vendor Product Name <span style={{ color: "red" }}> *</span></label>
                <input
                  name="productName"
                  placeholder="Enter Name"
                  className="required-but-empty"
                  value={
                    formData?.articleName ||
                    formData?.vendorProductInfo?.vendorProductName
                  }
                  onChange={handleChange}
                  type="texy"
                />
                {errors.productName && (
                  <span className="error-text" style={{ color: "red" }}>{errors.productName}</span>
                )}
              </div>
              <div className="form-control">
                <label>Weight (In Gsm)<span style={{ color: "red" }}> *</span></label>
                <div >
                  <input
                    type="number"
                    placeholder="in gsm"
                    name="weight"
                    className="required-but-empty"
                    value={formData?.metrics?.weight || ""}
                    onChange={handleChange}
                  />
                  {errors.weight && (
                    <span className="error-text" style={{ color: "red" }}>{errors.weight}</span>
                  )}
                </div>
              </div>
              <div className="form-control">
                <label>Width<span style={{ color: "red" }}> *</span></label>
                <input
                  name="width"
                  placeholder="Enter Width"
                  className="required-but-empty"
                  value={formData?.metrics?.width || ""}
                  onChange={handleChange}
                  type="texy"
                />
                {errors.width && (
                  <span className="error-text" style={{ color: "red" }}>{errors.width}</span>
                )}
              </div>
              <div className="form-control">
                <label>UOM</label>
                <div className="radio-group" style={{ display: "flex" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      name="uom"
                      value="isKg"
                      checked={formData.otherInformation?.unitOfMeasures?.isKg}
                      onChange={handleChange}
                    />
                    <span style={{ marginLeft: "5px" }}> Kg</span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      name="uom"
                      value="isMeter"
                      checked={
                        formData.otherInformation?.unitOfMeasures?.isMeter
                      }
                      onChange={handleChange}
                    />
                    <span style={{ marginLeft: "5px" }}> Meter </span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      name="uom"
                      value="isYard"
                      checked={
                        formData.otherInformation?.unitOfMeasures?.isYard
                      }
                      onChange={handleChange}
                    />
                    <span style={{ marginLeft: "5px" }}> Yard</span>
                  </label>
                </div>
              </div>
              <div className="form-control">
                <label>Price (₹)<span style={{ color: "red" }}> *</span></label>
                <div >
                  <input
                    type="number"
                    name="costPrice"
                    placeholder="Enter Price"
                    inputMode="numeric"
                    className="required-but-empty"
                    value={
                      (formData?.vendorProductInfo?.costPrice &&
                        formData?.priceSetting?.costPrice) ||
                      ""
                    }
                    onChange={handleChange}
                  />
                  {errors.costPrice && (
                    <span className="error-text" style={{ color: "red" }}>{errors.costPrice}</span>
                  )}
                </div>
              </div>
              <div className="form-control">
                <label>Commission %<span style={{ color: "red" }}> *</span></label>
                <div >
                  <input
                    type="number"
                    name="commissionPercentage"
                    placeholder="Enter Percentage"
                    inputMode="numeric"
                    className="required-but-empty"
                    value={formData?.vendorProductInfo.commissionPercentage}
                    onChange={handleChange}
                  />
                  {errors.commissionPercentage && (
                    <span className="error-text" style={{ color: "red" }}>{errors.commissionPercentage}</span>
                  )}
                </div>
              </div>
              <div className="form-control">
                <label>CHARGE ROLL WT / METERS</label>

                <div className="radio-group" style={{ display: "flex" }}>

                  <label style={{ display: "flex", alignItems: "center", marginRight: "10px" }}>
                    <input
                      type="radio"
                      name="chargeRoll"
                      value="true"
                      checked={formData?.chargeRoll === "true"}
                      onChange={handleChange}
                    />
                    <span style={{ marginLeft: "5px" }}>YES</span>
                  </label>

                  <label style={{ display: "flex", alignItems: "center" }}>
                    <input
                      type="radio"
                      name="chargeRoll"
                      value="false"
                      checked={formData?.chargeRoll === "false"}
                      onChange={handleChange}
                    />
                    <span style={{ marginLeft: "5px" }}>NO</span>
                  </label>

                </div>
              </div>
              {formData?.chargeRoll === "true" && (
                <>
                  <div className="form-control">
                    <label>Cone Weight (grms)<span style={{ color: "red" }}> *</span></label>
                    <input
                      type="number"
                      name="coneWeight"
                      value={formData?.otherInformation?.coneWeight || ""}
                      onChange={handleChange}
                      placeholder="Enter Cone Weight (in grms)"
                    />
                    {errors.coneWeight && (
                      <span className="error-text" style={{ color: "red" }}>{errors.coneWeight}</span>
                    )}
                  </div>

                  <div className="form-control">
                    <label>Standard Weight/(Kg/Meter)<span style={{ color: "red" }}> *</span></label>
                    <input
                      type="number"
                      name="standardRollWt"
                      value={formData?.vendorProductInfo?.standardRollWt || ""}
                      onChange={handleChange}
                      placeholder="Enter Standard Weight"
                    />
                    {errors.standardRollWt && (
                      <span className="error-text" style={{ color: "red" }}>{errors.standardRollWt}</span>
                    )}
                  </div>
                </>
              )}
              {/* <div className="form-control">
                <label>Product Typess</label>
                <div className="radio-group" style={{ display: "flex" }}>
                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      name="productType"
                      value="READYSTOCK"
                      checked={formData.productType === "READYSTOCK"}
                      onChange={handleChange}
                      required
                    />
                    <span style={{ marginLeft: "5px" }}>READY STOCK</span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      name="productType"
                      value="VENDORSTOCK"
                      checked={formData.productType === "VENDORSTOCK"}
                      onChange={handleChange}
                    />
                    <span style={{ marginLeft: "5px" }}> VENDOR STOCK </span>
                  </label>

                  <label
                    style={{
                      display: "flex",
                      alignItems: "center",
                      marginRight: "10px",
                    }}
                  >
                    <input
                      type="radio"
                      name="productType"
                      value="ORDERDRIVEN"
                      checked={formData.productType === "ORDERDRIVEN"}
                      onChange={handleChange}
                    />
                    <span style={{ marginLeft: "5px" }}> MADE TO ORDER</span>
                  </label>
                </div>
              </div> */}
              <div className="form-control">
                <label>Images<span style={{ color: "red" }}> *</span></label>
                <div className="pv-images-wrap" style={{ gap: "0px" }}>
                  <div className="pv-images-left">
                    <div
                      className={`pv-carousel-box ${allImages.length === 0 ? 'pv-empty' : 'pv-has-images'}`}
                      aria-live="polite"
                    >
                      {allImages.length === 0 ? (
                        <div className="pv-empty-placeholder" role="status" aria-label="No images uploaded">
                          <IconUpload size={20} />
                          <div className="pv-empty-text">No images</div>
                        </div>
                      ) : (
                        <Carousel
                          withIndicators
                          height={180}
                          slideSize="100%"
                          align="start"
                          withControls={allImages.length > 1}
                          loop
                          styles={{
                            indicator: {
                              width: 8,
                              height: 8,
                              backgroundColor: '#888',
                            },
                          }}
                        >
                          {allImages.map((file, index) => (
                            <Carousel.Slide key={index} className="pv-carousel-slide">
                              <div className="pv-carousel-inner">
                                <img
                                  src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                                  alt={`Uploaded-${index}`}
                                />
                                <Button
                                  size="xs"
                                  color="red"
                                  disabled={formData?.draftProductId}
                                  className="pv-remove-btn"
                                  onClick={() => removeSingleFile(index)}
                                >
                                  ✕
                                </Button>
                              </div>
                            </Carousel.Slide>
                          ))}
                        </Carousel>
                      )}
                    </div>

                    <Group className="pv-btn-row">
                      <FileButton
                        resetRef={resetRef}
                        onChange={fileChangee}
                        accept="image/png,image/jpeg"
                        multiple
                      >
                        {(props) => (
                          <Button
                            {...props}
                            style={{ backgroundColor: "#8BC53F", color: "white" }}
                            disabled={formData.draftProductId ? true : false}
                          >
                            Add Images
                          </Button>
                        )}
                      </FileButton>

                      <Button
                        disabled={!imageFile || imageFile.length === 0 || formData.draftProductId}
                        color="red"
                        onClick={clearFilee}
                      >
                        Reset All
                      </Button>
                    </Group>
                  </div>
                </div>
                {errors.images && (
                  <span className="error-text" style={{ color: "red" }}>{errors.images}</span>
                )}
              </div>
              {/* {formData?.productType === "READYSTOCK" && <div className="form-control">
                <label>Standard Color Options</label>
                <div className="pv-images-wrap" style={{ gap: "0px" }}>
                  <div className="pv-images-left">
                    <div
                      className={`pv-carousel-box ${allstandardColorOptionsImages.length === 0 ? 'pv-empty' : 'pv-has-images'}`}
                      aria-live="polite"
                    >
                      {allstandardColorOptionsImages.length === 0 ? (
                        <div className="pv-empty-placeholder" role="status" aria-label="No images uploaded">
                          <IconUpload size={20} />
                          <div className="pv-empty-text">No Std Color Option images</div>
                        </div>
                      ) : (
                        <Carousel
                          withIndicators
                          height={180}
                          slideSize="100%"
                          align="start"
                          withControls={allstandardColorOptionsImages.length > 1}
                          loop
                          styles={{
                            indicator: {
                              width: 8,
                              height: 8,
                              backgroundColor: '#888',
                            },
                          }}
                        >
                          {allstandardColorOptionsImages.map((file, index) => (
                            <Carousel.Slide key={index} className="pv-carousel-slide">
                              <div className="pv-carousel-inner">
                                <img
                                  src={typeof file === 'string' ? file : URL.createObjectURL(file)}
                                  alt={`Uploaded-${index}`}
                                />
                                <Button
                                  size="xs"
                                  color="red"
                                  disabled={formData?.draftProductId}
                                  className="pv-remove-btn"
                                  onClick={() => removeSingleStdFile(index)}
                                >
                                  ✕
                                </Button>
                              </div>
                            </Carousel.Slide>
                          ))}
                        </Carousel>
                      )}
                    </div>

                    <Group className="pv-btn-row">
                      <FileButton
                        resetRef={resetRef}
                        onChange={fileStdChangee}
                        accept="image/png,image/jpeg"
                        multiple
                      >
                        {(props) => (
                          <Button
                            {...props}
                            style={{ backgroundColor: "#8BC53F", color: "white" }}
                            disabled={formData.draftProductId ? true : false}
                          >
                            Add Std Images
                          </Button>
                        )}
                      </FileButton>

                      <Button
                        disabled={!imageStdFile || imageStdFile.length === 0 || formData.draftProductId}
                        color="red"
                        onClick={clearStdFilee}
                      >
                        Reset All
                      </Button>
                    </Group>
                  </div>
                </div>
              </div>} */}
              <div className="form-control">
                <b>Fabric Content<span style={{ color: "red" }}> *</span></b>
                <div className="fabric-content-inner-top-pt">
                  <div>
                    <h2 style={{ marginTop: "10px" }}>Fabric Content Code</h2>
                    <B2BInput
                      className="input-textField"
                      value={fCCValue}
                      type="text"
                      disabled={true}
                      clearable={fCCValue ? "×" : false}
                    />
                  </div>
                  <div>
                    <h2 style={{ marginTop: "10px" }}>Combination</h2>
                    <B2BSelect
                      value={formData?.fabricValue}
                      data={
                        fabricValue
                          ?.filter((v) => v?.value)
                          ?.map((v) => ({
                            value: v.value,
                            label: v.value,
                          })) || []
                      }
                      onChange={(e) => ChangeHandlerFabric(e)}
                      clearable={true}
                      disabled={
                        !!formData?.draftProductId && formData.editFabricContent
                      }
                      placeholder="Select FCC Combination"
                      className="input-textField"
                    />
                    {errors.fabricContent && (
                      <span className="error-text" style={{ color: "red" }}>{errors.fabricContent}</span>
                    )}
                  </div>
                </div>
                <div
                  className="fabric-content-inner-bottom"
                  style={{ marginTop: "5px" }}
                >
                  <div className="fabric-content-g-row">
                    <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-2">
                      <label>
                        <span className="fabric-content-text-label">
                          Fabric
                        </span>
                        <span className="error-message"> *</span>
                      </label>
                    </div>
                    <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-2">
                      <label>
                        <span className="fabric-content-text-label">
                          Composition(%)
                        </span>
                        <span className="error-message"> *</span>
                      </label>
                    </div>
                  </div>
                  {hasValidFabricContent ? selectedPairsFabric.map((pair, index) => (
                    <div
                      key={index}
                      className="fabric-content-g-row"
                      style={{ display: "flex", gap: "15px" }}
                    >
                      <div style={{ display: "flex", marginBottom: "5px" }}>
                        <B2BSelect
                          value={selectedPairsFabric[index]?.key || ""}
                          data={getAvailableKeysFabric(index).map((key) => ({
                            value: key,
                            label: keyToNameMap[key],
                          }))}
                          clearable={true}
                          disabled={
                            !!formData?.draftProductId &&
                            formData.editFabricContent
                          }
                          onChange={(e) => handleSelectChangeFabric(index, e)}
                        />
                      </div>
                      <div>
                        <NumberInput
                          value={pair.value || 0}
                          required={true}
                          disabled={
                            !pair.key ||
                            (!!formData?.draftProductId &&
                              formData?.editFabricContent)
                          }
                          clearable={true}
                          max={100}
                          onChange={(e) =>
                            handleMultiSelectChangeFabric(index, e)
                          }
                          rightSection={<IconPercentage size={20} />}
                        />
                        {index > 0 && (
                          <button
                            type="button"
                            className="fabric-content-btn fabric-content-btn--icon-no fabric-content-ml2"
                            style={{ marginLeft: "10px" }}
                            disabled={
                              !!formData?.draftProductId &&
                              formData?.editFabricContent
                            }
                            onClick={() => removePairFabric(index, pair.value)}
                          >
                            <FontAwesomeIcon
                              className="fa fabric-content-icon"
                              icon={FaTrash}
                            />
                          </button>
                        )}
                      </div>
                    </div>
                  )) : ''}
                  <div className="fabric-content-g-row">
                    {totalPercent < 100 && (
                      <div className="fabric-content-g-col fabric-content-g-s-6 fabric-content-g-m-4">
                        <button
                          type="button"
                          className="fabric-content-btn fabric-content-btn--text-go"
                          onClick={addNewPairFabric}
                        >
                          <FontAwesomeIcon
                            className="fa fabric-content-icon fabric-content-mr2"
                            icon={FaPlus}
                          />
                          Add another attribute
                        </button>
                      </div>
                    )}
                  </div>
                  {errors.fabricPercent && (
                    <span className="error-text" style={{ color: "red" }}>{errors.fabricPercent}</span>
                  )}
                  <div>
                    <p className="fabric-label">
                      Overall Composition Percentage is: {totalPercent}
                    </p>
                  </div>
                </div>
              </div>
              <div className="form-control">
                <label>
                  Fiber <span style={{ color: "red" }}> *</span>
                </label>
                <input
                  name="fiber"
                  placeholder="Enter Fiber"
                  className="required-but-empty"
                  value={formData.fiber || ""}
                  onChange={handleChange}
                  type="text"
                />
                {errors.fiber && (
                  <span className="error-text" style={{ color: "red" }}>
                    {errors.fiber}
                  </span>
                )}
              </div>
              <div className="checkbox-container" onClick={handleCheckboxClick}>
                <div className={`app-checkbox ${isChecked ? "checked" : ""}`}>
                  <div className="circle">{isChecked && "✔"}</div>
                </div>
                I confirm that this new development is related to a single piece
                of garment fabric.
              </div>
              <button
                type="submit"
                disabled={!isChecked || isSubmitting}
                style={{
                  display: "flex",
                  justifyContent: "center",
                  borderRadius: "5px",
                  cursor: !isChecked || isSubmitting ? "not-allowed" : "pointer",
                  backgroundColor: !isChecked || isSubmitting ? "gray" : "#8BC53F",
                }}
                className="btninqury btninqury-primary btninqury-submit"
              >
                {isSubmitting ? "Submitting Development..." : "Submit New Development"}
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default VendorFabricInquiryNewDetails;
